import styled from 'styled-components';
import { CheckboxRoot } from '../Checkbox/Checkbox.styles';
import { LabelLargeStyles, ParagraphMediumStyles } from '../Typography/Typography.styles';
import { ListItemWrapperProps, ListItemSecondaryTextProps } from './ListItem.types';

export const ListItemWrapper = styled.li<ListItemWrapperProps>`
  ${LabelLargeStyles};
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  cursor: pointer;
  outline: none;
  transition: background 0.2s ease-in-out;
  box-sizing: border-box;
  padding: ${({ hasSecondaryText }) => (hasSecondaryText ? '20px 16px' : '8px 16px')};

  background: ${({ selected, theme }) => {
    const colors = theme[theme.color].ListItem.color;

    return selected ? colors.focused : colors.normal;
  }};

  color: ${({ disabled, theme }) => {
    const colors = theme[theme.color].ListItem.text;

    return disabled ? colors.disabled : colors.normal;
  }};

  &:hover,
  &:focus {
    background: ${({ selected, theme }) => {
      const colors = theme[theme.color].ListItem.color;

      return selected ? colors.focused : colors.hover;
    }};
  }

  &[disabled] {
    pointer-events: none;
    user-select: none;
  }
`;

export const ListItemRoot = styled.div`
  display: inline;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  ${CheckboxRoot} {
    pointer-events: none;
    margin-right: 12px;
  }
`;

export const SecondaryActionRoot = styled.div`
  ${ParagraphMediumStyles};
  margin-left: auto;
`;

export const ListItemSubtitle = styled.span<ListItemSecondaryTextProps>`
  ${ParagraphMediumStyles};
  display: block;
  margin-top: 5px;

  color: ${({ theme, disabled }) => {
    const colors = theme[theme.color].ListItem.subtitle;

    return disabled ? colors.disabled : colors.normal;
  }};
`;
